import { Button } from '@uswitch/spark.button'
import React from 'react'

import * as st from '../styles'

export const ModalButton = ({ buttonOnClick, link }) => {
  return (
    <Button
      as='a'
      onClick={buttonOnClick}
      size='large'
      href={link.url}
      target='_blank'
      sx={{ ...st.modalButton, backgroundColor: 'black' }}
    >
      {link.text}
    </Button>
  )
}
